// Libraries
import { action, computed, observable } from "mobx";

// Core
import { ModelBase } from "Core/Models/ModelBase";

export class InspectionDocumentModel extends ModelBase<InspectionDocumentModel, InspectionDocumentDTO> {
    // #region Properties

    @observable
    public id = "";

    @observable
    public companyId = "";

    @observable
    public propertyId = "";

    @observable
    public inspectionStageId = "";

    @observable
    public uploadedByIdentityUserId = "";

    @observable
    public imageUrl = "";

    @observable
    public fileName = "";

    @observable
    public uploadedDate = "";

    @observable
    public canViewInCustomerPortal = false;

    // #endregion Properties
    @action
    public fromDto = (dto: InspectionDocumentDTO): void => {
        this.id = dto.id;
        this.companyId = dto.companyId;
        this.propertyId = dto.propertyId;
        this.inspectionStageId = dto.inspectionStageId;
        this.uploadedByIdentityUserId = dto.uploadedByIdentityUserId;
        this.fileName = dto.fileName;
        this.imageUrl = dto.imageUrl;
        this.uploadedDate = dto.uploadedDate;
        this.canViewInCustomerPortal = dto.canViewInCustomerPortal;
    };

    public toDto = (): InspectionDocumentDTO => {
        throw "toDto is not supported";
    };
}

export interface InspectionDocumentDTO {
    id: string;
    companyId: string;
    propertyId: string;
    inspectionStageId: string;
    uploadedByIdentityUserId: string;
    fileName: string;
    imageUrl: string;
    uploadedDate: string;
    canViewInCustomerPortal: boolean;
}
